import { render, staticRenderFns } from "./ThirdPartyRegistration.vue?vue&type=template&id=d3560b1e&scoped=true"
import script from "./ThirdPartyRegistration.vue?vue&type=script&lang=js"
export * from "./ThirdPartyRegistration.vue?vue&type=script&lang=js"
import style0 from "./ThirdPartyRegistration.vue?vue&type=style&index=0&id=d3560b1e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3560b1e",
  null
  
)

export default component.exports